require('./navigation.js');
require('./custom.js');

//Slick-slider
//require('slick-carousel/slick/slick.js');

//FontAwesome All in one file
//require('@fortawesome/fontawesome-pro/js/all.js');

//FontAwesome parts

// Core
require('@fortawesome/fontawesome-pro');
import { library as FontAwesomeLibrary, config, dom } from '@fortawesome/fontawesome-svg-core';
config.autoA11y = true;
config.observeMutations = true;
config.autoReplaceSvg = true;

import { faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch} from '@fortawesome/pro-solid-svg-icons';
import { faBars, faTimes } from '@fortawesome/pro-regular-svg-icons';


FontAwesomeLibrary.add(faTimes, faBars, faTwitter, faFacebook, faInstagram, faYoutube, faLinkedin, faEnvelope, faPhone, faShoppingCart, faMapMarkerAlt, faSearch);

dom.watch();

/*
Ikonikirjastot:
free-brands-svg-icons
pro-light-svg-icons
pro-regular-svg-icons
pro-solid-svg-icons
*/


// Brands
//require('@fortawesome/fontawesome-pro/js/brands.js');

// Light
//require('@fortawesome/fontawesome-pro/js/light.js');

// Regular
//require('@fortawesome/fontawesome-pro/js/regular.js');

// Solid
//require('@fortawesome/fontawesome-pro/js/solid.js');

// v4-shims
//require('@fortawesome/fontawesome-pro/js/v4-shims.js');

jQuery('document').ready(function($){
  $('.icon button').on('click touchstart', function() {
    $(this).find('svg').toggleClass('menu-closed menu-opened');
    $('.menu-opened').html('<svg width="34" height="34" viewBox="0 0 34 34" fill="none"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#000723"/></svg>');
    $('.menu-closed').html('<svg width="34" height="34" viewBox="0 0 34 34" fill="none"><path d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z" fill="#000723"/></svg>');
    $('.site-menu').toggleClass('mobile-fixed-close');
    $('.header-shop-icons').toggleClass('header-shop-icons-opened');
    $('li').removeClass('linkki-teksti');
  });
});
